import { ScrollReveal } from '@/components/ui/scroll-reveal'
import { Bot, BrainCircuit, Sparkles } from 'lucide-react'

export const AiSection = () => {
  return (
    <section className="py-24 bg-white border-y border-slate-100">
      <div className="container px-4 md:px-6 text-center max-w-4xl mx-auto">
        <ScrollReveal>
          <div className="inline-flex items-center justify-center space-x-2 mb-6 px-4 py-1.5 rounded-full bg-indigo-50 text-indigo-700 font-medium text-sm border border-indigo-100">
            <Sparkles size={16} />
            <span>Tecnologia ao serviço das pessoas</span>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-8">
            O papel da Inteligência Artificial
          </h2>

          <div className="grid md:grid-cols-3 gap-8 mb-10">
            <div className="flex flex-col items-center p-6 rounded-xl bg-slate-50">
              <Bot className="w-10 h-10 text-primary mb-4" />
              <h3 className="font-bold text-slate-900 mb-2">Análise</h3>
              <p className="text-sm text-slate-600">
                Identifica padrões e anomalias nos dados operacionais.
              </p>
            </div>
            <div className="flex flex-col items-center p-6 rounded-xl bg-slate-50">
              <BrainCircuit className="w-10 h-10 text-primary mb-4" />
              <h3 className="font-bold text-slate-900 mb-2">Sugestão</h3>
              <p className="text-sm text-slate-600">
                Propõe ações baseadas no histórico do negócio.
              </p>
            </div>
            <div className="flex flex-col items-center p-6 rounded-xl bg-slate-50">
              <Sparkles className="w-10 h-10 text-primary mb-4" />
              <h3 className="font-bold text-slate-900 mb-2">Automação</h3>
              <p className="text-sm text-slate-600">
                Executa respostas automáticas para reduzir erros repetitivos.
              </p>
            </div>
          </div>

          <p className="text-lg text-slate-600 leading-relaxed max-w-3xl mx-auto">
            A inteligência artificial é usada como apoio à operação, não como
            substituto do controlo humano. As aplicações podem analisar dados,
            identificar padrões, sugerir ações, automatizar respostas e reduzir
            erros repetitivos, ajudando a equipa a tomar decisões mais rápidas e
            informadas.
          </p>
        </ScrollReveal>
      </div>
    </section>
  )
}
